<div class="signature-pad">
    <canvas [width]="width" [height]="height" #canvas></canvas>
    <div class="full-width signed-on">
        <p *ngIf="!hideDetails">Signed</p>
        <p *ngIf="!hideDetails">{{today}}</p>
        <button mat-button color="primary" [class]="clearButtonClass" (click)="clearPad()">Reset</button>
    </div>
    <div class="buttons">
        <button type="button" [class]="doneButtonClass" *ngIf="showDoneButton" (click)="emitPointsAndBlob()">{{
            doneButtonText }}</button>
        <button type="button" [class]="clearButtonClass" *ngIf="showClearButton" (click)="clearPad()">{{ clearButtonText
            }}</button>
    </div>
    <!-- <div class="form-toggle" *ngIf="!hideDetails">
        <mat-slide-toggle [(ngModel)]="signAsGuardian" color="primary" class="">Sign as
            Parent/Guardian/Authorised Relative/Curator/Mandated Person</mat-slide-toggle>
    </div> -->

    <div class="guardian-fields" *ngIf="!hideDetails">
        <mat-form-field appearance="outline">
            <mat-label>Signatory Name</mat-label>
            <input matInput [(ngModel)]="guardianName" placeholder="Enter signatory name" [required]="signatoryRequired"
                [errorStateMatcher]="signatoryErrorMatcher" (ngModelChange)="onGuardianNameChange()">
            <mat-error *ngIf="signatoryRequired && !guardianName?.trim()">
                Signatory name is required
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Delegation</mat-label>
            <mat-select [(ngModel)]="signatoryDelegation" [required]="signatoryRequired"
                [errorStateMatcher]="signatoryErrorMatcher" (ngModelChange)="onDelegationChange()">
                <mat-option value="Patient">Patient</mat-option>
                <mat-option value="Parent">Parent</mat-option>
                <mat-option value="Guardian">Guardian</mat-option>
                <mat-option value="Spouse/Partner">Spouse/Partner</mat-option>
                <mat-option value="Caregiver">Caregiver</mat-option>
                <mat-option value="Power of Attorney">Power of Attorney</mat-option>
                <mat-option value="Caregiver">Caregiver</mat-option>
                <mat-option value="Authorised Relative">Authorised Relative</mat-option>
                <mat-option value="Healthcare Proxy">Healthcare Proxy</mat-option>
                <mat-option value="Mandated Person">Mandated Person</mat-option>
                <mat-option value="Legal Representative">Legal Representative</mat-option>
                <mat-option value="Curator">Curator</mat-option>
                <mat-option value="Foster Parent">Foster Parent</mat-option>
                <mat-option value="Case Manager">Case Manager</mat-option>
                <mat-option value="Social Worker">Social Worker</mat-option>
            </mat-select>
            <mat-error *ngIf="signatoryRequired && !signatoryDelegation?.trim()">
                Delegation is required
            </mat-error>
        </mat-form-field>
    </div>

</div>